import {createAsyncThunk} from "@reduxjs/toolkit";
import axios, {AxiosError} from "axios";

import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {setNotFoundError} from "features/model/slice/error/errorSlice";
import {setCalendar} from "features/model/slice/calendar/calendarSlice";


interface FetchCalendarParams {
    groupId: string;
}


export const fetchCalendar = createAsyncThunk(
    "groups/fetchLessonsByGroupsId",
    async ({ groupId}: FetchCalendarParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);

            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.get<any>(
                `/api/groups/${groupId}/calendar`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setCalendar(response.data));
            }
            return response.data;
        } catch (error) {
            thunkAPI.dispatch(setNotFoundError((error as AxiosError).response!.status));
        }
    }
);
